module.exports = "<div class=\"m-scroll-top\" appunwraptag=\"\" *ngIf=\"isShown\" (click)=\"scrollToTop()\">\n  <i class=\"la la-arrow-up\"></i>\n</div>"